// extracted by mini-css-extract-plugin
export default {"menuLabel":"menuLabel_J_DnI","remind":"remind_Nr_4f"};